import React, { Component } from 'react';
import Firebase, { withFirebase } from '../Firebase';
import { Alert, Button, FormControl, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const PasswordForgetPage = () => (
  <div>
    <h1>Password Forget</h1>
    <PasswordForgetForm />
  </div>
);

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { email } = this.state;
    const { firebase } = this.props;

    firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch((error) => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error } = this.state;

    const isInvalid = email === '';

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <FormControl>
          <TextField
            name="email"
            value={email}
            onChange={this.onChange}
            type="text"
            label="Email Address"
          />
        </FormControl>
        {error && <Alert severity="error">{error.message}</Alert>}
        <Button disabled={isInvalid} onClick={this.onSubmit} color="primary" variant="contained">
          Reset My Password
        </Button>
      </div>
    );
  }
}

PasswordForgetFormBase.propTypes = {
  firebase: PropTypes.instanceOf(Firebase).isRequired,
};

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm };
